import React from 'react'
import PropType from 'prop-types'
import { connect } from 'react-redux'
import Loader from 'components/loader'
import ErrorDefault from 'components/error/error-default'
import { getAuthStatus } from 'lib/utils/common/commonUtils'
import ReferralDesktopLanding from './landing-desktop'
import { isReferralAvailable } from '../utils'

const ReferralLanding = ({
  auth,
  isPhone,
  internationalization: { shop },
  ref_type,
}) => {
  const authStatus = getAuthStatus(auth)
  const isGuest = authStatus.isFetched && authStatus.isGuest
  const isLoyaltyMember = authStatus.isFetched && authStatus.isLoyaltyMember
  const referralFlagStatus = isReferralAvailable(shop) // 'Referral-20220614'

  if (!authStatus.isFetched) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    )
  }

  if (!referralFlagStatus) {
    return (
      <ErrorDefault
        isPhone={isPhone}
        showDefaultError
        showPDPError={false}
        showSearch
      />
    )
  }

  return (
    <ReferralDesktopLanding
      isGuest={isGuest}
      isLoyaltyMember={isLoyaltyMember}
      ref_type={ref_type}
    />
  )
}

ReferralLanding.propTypes = {
  auth: PropType.shape({
    customerData: PropType.shape({
      isFetched: PropType.bool,
      loyalty_signup: PropType.number,
    }).isRequired,
  }).isRequired,
  isPhone: PropType.bool.isRequired,
  internationalization: PropType.shape({
    shop: PropType.number,
  }).isRequired,
  ref_type: PropType.string.isRequired,
}

export default connect((state) => ({
  auth: state.auth,
  isPhone: state.device.isPhone,
  internationalization: state.internationalization,
}))(ReferralLanding)
